// Types
import Strategy from 'app/types/Strategy';
import MixpanelEvents from 'app/features/mixpanel/MixpanelEvents';
// Services
import Mixpanel from "app/services/Mixpanel.service";

export const handleEpisodeSuggestedAuthorClickStrategy:Strategy = (payload, { caseId, userId, accountId }) => {
  const { authorId, authorName } = payload;
  Mixpanel.track(MixpanelEvents.EpisodeSuggestedAuthorClick, {
    accountId,
    userId,
    caseId,
    authorId,
    authorName
  });
};
